import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment } from '../../components/navigation/AssessmentStateManager';
import ProgressTracker from '../../components/navigation/ProgressTracker';
import DiagnosisSection from './components/DiagnosisSection';
import PivotSection from './components/PivotSection';
import CTASection from './components/CTASection';
import StickyCTA from './components/StickyCTA';
import { trackViewContentAPI } from '../../utils/conversionAPI';

const PersonalizedResults = () => {
  const navigate = useNavigate();
  const { state, setScreen } = useAssessment();

  useEffect(() => {
    setScreen('personalized-results');
    
    // Track results view with Conversion API
    const { dominant } = getDominantAndSecondary();
    trackViewContentAPI(`Results - ${dominant}`, 'Assessment Results');
  }, [setScreen]);

  const getDominantAndSecondary = () => {
    const scores = state?.archetypeScores || {};
    const sortedArchetypes = Object.entries(scores)?.sort(([, a], [, b]) => b - a);
    
    // Valid archetype names
    const validArchetypes = ['performer', 'ghost', 'controller', 'pleaser', 'destroyer'];
    
    // Validate and normalize archetype names from stored data
    const validateArchetype = (name, fallback) => {
      if (!name) return fallback;
      const normalized = name?.toString()?.toLowerCase()?.trim();
      return validArchetypes?.includes(normalized) ? normalized : fallback;
    };
    
    return {
      dominant: validateArchetype(sortedArchetypes?.[0]?.[0], 'ghost'),
      secondary: validateArchetype(sortedArchetypes?.[1]?.[0], 'performer')
    };
  };

  const { dominant, secondary } = getDominantAndSecondary();

  return (
    <div className="min-h-screen bg-brand-black">
      <ProgressTracker
        currentScreen="personalized-results"
        completionPercentage={100}
      />

      <main className="pt-20 md:pt-24 pb-32 md:pb-40 px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 text-brand-gold rounded-md text-sm font-bold uppercase tracking-wide mb-4">
              <span className="w-2 h-2 bg-brand-gold rounded-full animate-pulse" />
              Assessment Complete
            </div>
          </div>

          {/* Section 1: The Pivot */}
          <PivotSection dominant={dominant} />

          {/* Section 2: The Diagnosis */}
          <DiagnosisSection dominant={dominant} secondary={secondary} />

          {/* Section 4: The CTA */}
          <CTASection dominant={dominant} secondary={secondary} />
        </div>
      </main>

      {/* Sticky CTA */}
      <StickyCTA />
    </div>
  );
};

export default PersonalizedResults;